// extracted by mini-css-extract-plugin
export var deleteModal = "_hb-0";